import React from "react";
import { useNavigate } from "react-router-dom";
import { GenericErrorIcon } from "src/assets/icons/GenericErrorIcon";
import { GoBackIcon } from "src/assets/icons/GoBackIcon";
import { translate } from "src/lib/i18n";
import { colors } from "@aifi-ml/design-system-variables";
import { styles } from "./styles";
import { GoBackButton } from "./GoBackButton";

export const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const iconWrapperStyle = {
    ...styles.iconWrapper,
    backgroundColor: colors.light['color/surface/background/tertiary'],
  };

  return (
    <div style={styles.notFoundPanel}>
      <div style={styles.errorCodeBackground}>404</div>
      <div style={styles.notFoundCard}>
        <div style={iconWrapperStyle}>
          <GenericErrorIcon width={40} height={40} />
        </div>
        <h2 style={styles.notFoundTitle}>{translate("notFound.title")}</h2>
        <p style={styles.notFoundMessage}>{translate("notFound.message")}</p>
        <GoBackButton onClick={handleGoBack}>
          <GoBackIcon width={24} height={24} color={colors.light['color/text/general/active']} />
          {translate("notFound.goBack")}
        </GoBackButton>
      </div>
    </div>
  );
};
